import { useCallback } from "react";

const CONTAINER_URL = "https://blogscraping.blob.core.windows.net/blogs";

const useBlogStorage = () => {
  // List all markdown filenames in the container
  const listMarkdowns = useCallback(async () => {
    const res = await fetch(`${CONTAINER_URL}?restype=container&comp=list`);
    if (!res.ok) throw new Error("Failed to list blogs");
    const xml = await res.text();
    const parser = new window.DOMParser();
    const xmlDoc = parser.parseFromString(xml, "application/xml");
    return Array.from(xmlDoc.getElementsByTagName("Name"))
      .map(node => node.textContent)
      .filter(name => name && name.endsWith('.md'));
  }, []);

  // Fetch the content of a single markdown file by filename
  const fetchMarkdown = useCallback(async (filename: string) => {
    const res = await fetch(`${CONTAINER_URL}/${filename}`);
    if (!res.ok) throw new Error(`Failed to fetch blog: ${filename}`);
    return await res.text();
  }, []);

  return { listMarkdowns, fetchMarkdown };
};

export default useBlogStorage; 